module.exports = __webpack_public_path__ + "static/media/logo.bcca66ec.png";